<template>
	<div class="StudyStaff" v-if="selectedStudy && currentTab">
		<v-row class="mb-6" no-gutters>
			<v-col :cols="8">
				<v-row no-gutters>
					<h2 class="left-align">Manage Study Staff</h2>
				</v-row>
				<v-row no-gutters>
					<v-btn
					  :disabled="selected.length == 0"
					  @click="removeStaffDialog = true"
					  class="btn-link-left text-none"
					  text
					>
						Remove Selected Staff
					</v-btn>
				</v-row>
			</v-col>
			<v-col :cols="4">
				<br>
				<v-btn @click="addMemberDialog = true" class="btn-default" text>Add New Staff Member</v-btn>
			</v-col>
		</v-row>
		<div v-show="headers.length !== 0" class="study-staff-table-container">
			<v-data-table
			  v-model="selected"
			  :headers="headers"
			  :items-per-page="itemsPerPage"
			  :items="staffList"
			  :page.sync="page"
			  @page-count="pageCount = $event"
			  class="elevation-1"
			  item-key="userName"
			  hide-default-footer
			  show-select
			>
				<template
				  v-for="h in headers"
				  v-slot:[`header.${h.value}`]="{ header }"
				>
					<v-tooltip
					  :key="h.value"
					  :disabled="h.hover === ''"
					  color="#333"
					  bottom
					>
						<template v-slot:activator="{ on }">
							<span
							  v-on:keyup.enter="(e) => e.target.click()"
							  v-on="on"
							  class="columnTitleText"
							  tabIndex="0"
							>
								{{ h.text }}
							</span>
						</template>
						<span>{{ h.hover }}</span>
					</v-tooltip>
				</template>
				<!-- for the check box header -->
				<template v-slot:header.data-table-select="{ value, selected }">
					<v-checkbox
					  :selected="selected"
					  :value="value"
					  @change="checkboxHeader"
					  class="mt-0"
					  aria-label="select all"
					  hide-details
					>
					</v-checkbox>
				</template>
				<!-- for the check boxes -->
				<template v-slot:item.data-table-select="{ item, isSelected }">
					<v-checkbox
					  :disabled="item.email === userInfo.email || item.email === selectedStudy.primaryEmail"
					  :isSelected="item"
					  :value="isSelected"
					  @change="checkboxData(item)"
					  class="mt-0"
					  aria-label="staff"
					  hide-details
					>
					</v-checkbox>
				</template>
				<template v-slot:item.notificationBox="{ item }">
					<v-checkbox
					  v-model="item.subbedEmailNotifications"
					  @click="changeNotificationStatus(item)"
					  aria-label="Receive Notifications"
					>
					</v-checkbox>
				</template>
			</v-data-table>
			<div class="pagination-container">
				<v-row>
					<v-col :cols="2">
						<v-text-field
						  :value="itemsPerPage"
						  @input="itemsPerPage = parseInt($event, 10)"
						  label="Items per page"
						  max="15"
						  min="1"
						  type="number"
						>
						</v-text-field>
					</v-col>
					<v-col :cols="10">
						<v-pagination v-model="page" :length="pageCount"></v-pagination>
					</v-col>
				</v-row>
			</div>
		</div>
		<foe-dialog
		  v-model="addMemberDialog"
		  :dialogW="addMemberDialog"
		  class="add-staff-dialog"
		  max-width="600px"
		  persistent
		>
			<v-card class="study-manage-staff-card">
				<v-card-title class="headline">
					<h3 class="headline">Manage Study Staff Access</h3>
				</v-card-title>
				<v-card-text class="left-align">
					Add Study Staff
				</v-card-text>
				<!-- :error="errorAddResearcher2"
	:error-messages="errorAddResearcher2 ? errorAddResearcherMessage2:[]" -->

				<fieldset class="border-0">
					<legend class="d-sr-only">
						Add Study Staff
					</legend>

					<v-radio-group
					  v-model="addStaffSelection"
					  @change="clearError"
					  class="add-staff-radio-group"
					>
						<v-radio label="Add an existing researcher to the study staff." value="1"></v-radio>
						<v-radio label="Create and add a new researcher to the study staff." value="2"></v-radio>
					</v-radio-group>

				</fieldset>

				<!-- //if error messag should be at top
		<div v-if="errorAddResearcher">
		<v-card-text class="red--text text-left" style="font-size: 16px;padding-left: 24px;padding-right: 24px;">
		*	{{ this.errorAddResearcherMessage}}
		</v-card-text>
		</div>
		-->
				<!-- TODO: add the two forms for each radio button selection (use radio selection for chosing which for to check as well) -->
				<div class="add-staff-form">
					<v-form v-if="addStaffSelection === '1'" ref="form1" v-model="valid1" lazy-validation>
						<v-text-field
						  v-model="email"
						  :rules="emailRules"
						  hide-details="auto"
						  label="*Email"
						  outlined
						>
						</v-text-field>
					</v-form>

					<v-form v-else-if="addStaffSelection === '2'" ref="form2" v-model="valid2" lazy-validation>
						<v-text-field
						  v-model="email"
						  :rules="emailRules"
						  hide-details="auto"
						  label="*Email"
						  outlined
						>
						</v-text-field>
						<br>
						<v-text-field
						  v-model="firstName"
						  :rules="requiredRule"
						  hide-details="auto"
						  label="*First Name"
						  outlined
						>
						</v-text-field>
						<br>
						<v-text-field
						  v-model="lastName"
						  :rules="requiredRule"
						  hide-details="auto"
						  label="*Last Name"
						  outlined
						>
						</v-text-field>
						<br>
						<v-text-field
						  v-model="organization"
						  :rules="requiredRule"
						  hide-details="auto"
						  label="*Organization"
						  outlined
						>
						</v-text-field>
						<br>
						<v-text-field
						  v-model="phoneNumber"
						  :rules="phoneRules"
						  hide-details="auto"
						  label="*Phone Number"
						  type="tel"
						  outlined
						>
						</v-text-field>
					</v-form>
				</div>
				<div v-if="errorAddResearcher">
					<br>
					<v-card-text class="text-left" style="font-size: 16px;padding-left: 24px;padding-right: 24px; color: #d32829">
						* {{ this.errorAddResearcherMessage }}
					</v-card-text>
				</div>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text class="btn-default" @click="onCancelAddStaff()">
						Cancel
					</v-btn>
					<v-btn text class="btn-default" @click="onAddStaff()" :loading="isAddingStaff">
						Add
					</v-btn>
				</v-card-actions>
			</v-card>
		</foe-dialog>

		<foe-dialog
		  v-model="removeStaffDialog"
		  :dialogW="removeStaffDialog"
		  class="delete-dialog"
		  max-width="600px"
		  persistent
		>
			<v-card class="remove-dialog">
				<v-card-title class="headline">
					<h3 class="headline">Remove Selected Study Staff</h3>
				</v-card-title>
				<v-card-text class="left-align">
					Do you want to remove the selected study staff from the study?
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text class="btn-default" @click="removeStaffDialog = false" :disabled="removeDialogLoading">
						Cancel
					</v-btn>
					<v-btn text class="btn-default" @click="removeSelected()" :loading="removeDialogLoading">
						Ok
					</v-btn>
				</v-card-actions>
			</v-card>
		</foe-dialog>
	</div>
</template>

<script>
import { researcherApiService } from '@/services/researcherApiService';
import { utilityService } from '@/services/utilityService.js';

export default {
	name: 'StudyStaff',
	props: {
	},
	data: () => ({
		addMemberDialog: false,
		removeStaffDialog: false,
		removeDialogLoading: false,
		selected: [],
		staffList: [],
		studyUuid: '',
		page: 1,
		pageCount: 0,
		itemsPerPage: 10,
		addStaffSelection: '',
		valid1: true,
		valid2: true,
		email: '',
		firstName: '',
		lastName: '',
		organization: '',
		phoneNumber: null,
		requiredRule: [v => v !== '' || 'This section is required'],
		phoneRules: [
			(v) => (/^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/.test(v) || (v) === '' || (v) === null || (v) === undefined) ||
				'Phone number must be proper format XXX-XXX-XXXX'],
		emailRules: [
			v => v !== '' || 'This section is required',
			v => (v && /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(v)) || 'Invalid email'
		],
		errorAddResearcher: false,
		errorAddResearcherMessage: '',
		isAddingStaff: false
	}),
	mounted() {
		this.updateStaff();
		var tableHeaderSelector = document.querySelector('.v-data-table-header th:first-child')
		tableHeaderSelector.setAttribute('aria-label', 'selected staff');
		// works for header but not rows/ maybe has something to do with data beig filled
		// var thing = document.querySelector('tbody td:first-child')
		// thing.setAttribute('aria-label', 'thing');
		//
	},
	watch: {
		addMemberDialog: function (newVal, oldVal) {
			this.$nextTick(function () {
				// 2021.10.20 - Sebastian Calle assisted with the following idea/solution
				// Code that will run only after the entire view has been rendered
				// var b = document.getElementById('form-study-purpose');
				// b.setAttribute('aria-labelledby', 'form-study-purpose-label')
				// 2021.10.25 - Yevgeniy editted above to target class name and remove aria-labelledby attribute for all elements
				// 2022.06.29 - CHT adding to edit study
				var vRadioGroup = document.getElementsByClassName('v-input--radio-group__input');
				for (let i = 0; i < vRadioGroup.length; i++) {
					vRadioGroup[i].removeAttribute('aria-labelledby');
				}
			});
		}
	},
	computed: {
		headers: function () {
			return [
				{ text: 'First Name', value: 'firstName', hover: '', class: 'data-table-header' },
				{ text: 'Last Name', value: 'lastName', hover: '', class: 'data-table-header' },
				{ text: 'Organization', value: 'organization', hover: '', class: 'data-table-header' },
				{ text: 'User Name', value: 'userName', hover: '', class: 'data-table-header' },
				{ text: 'Phone', value: 'phoneNumber', hover: '', class: 'data-table-header' },
				{ text: 'Receive Notifications?', value: 'notificationBox', hover: '', class: 'data-table-header' }
			]
		},
		selectedStudy: function () {
			// This computed property will update the study when the selected study is
			// modified in the store
			if (this.studyUuid !== this.$store.getters.getSelectedStudy.studyUuid) {
				this.updateStaff();
			}
			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			return this.$store.getters.getSelectedStudy;
		},
		currentTab: function () {
			const tabPosition = {
				tabIndex: parseInt(this.$store.getters.getCurrentStudyTabIndex),
				subTabIndex: parseInt(this.$store.getters.getCurrentStudySubTabIndex)
			};

			this.checkTabMatch(tabPosition);
			return tabPosition;
		},
		userInfo: function () {
			return this.$store.getters.getUserInfo;
		}
	},
	methods: {
		checkboxHeader(e) {
			if (e) {
				this.selectAll()
			} else {
				this.deselectAll()
			}
		},
		checkboxData(obj) {
			if (!this.selected.includes(obj)) {
				this.selected.push(obj)
			} else {
				for (var i = this.selected.length; i--;) {
					if (this.selected[i] === obj) this.selected.splice(i, 1);
				}
			}
		},
		selectAll() {
			const me = this;
			let staffFiltered = this.staffList.filter(word => word.email !== me.userInfo.email);
			staffFiltered = staffFiltered.filter(word => word.email !== me.selectedStudy.primaryEmail)
			this.selected = staffFiltered;
		},
		deselectAll() {
			this.selected = [];
		},
		async checkTabMatch({ tabIndex, subTabIndex } = {}) {
			var tabsPos = await utilityService.getTabsPositionByName('Edit Study Basics', this.$studyTabConfig);
			if (tabsPos.tabPos === tabIndex && tabsPos.subtabPos === subTabIndex) {
				this.$refs.firstFocusable.focus();
			}
		},
		updateStaff() {
			this.studyUuid = this.$store.getters.getSelectedStudy.studyUuid;
			const me = this;
			researcherApiService.loadStaff(this.studyUuid)
				.then(function (response) {
					if (response && response.data) {
						console.log('response.data', response.data)
						me.staffList = response.data
					}
				})
				.catch(function (e) {
					console.log(e);
				})
		},
		changeNotificationStatus(staff) {
			var fields = {
				subbedEmailNotifications: staff.subbedEmailNotifications
			}
			researcherApiService.updateUser(staff.userUuid, fields)
				.then(function (response) {
					if (response && response.data) {
						console.log(response.data)
					}
				});
		},
		onAddStaff() {
			var valid = false;
			switch (this.addStaffSelection) {
				case '1':
					valid = this.$refs.form1.validate();
					if (valid) {
						this.addExisting();
					}
					break;
				case '2':
					valid = this.$refs.form2.validate();
					if (valid) {
						this.addNew();
					}
			}
		},
		addExisting() {
			const me = this;
			this.isAddingStaff = true;
			researcherApiService.addExistingStaff(this.studyUuid, this.email)
				.then(function (response) {
					me.updateStaff();
					me.errorAddResearcher = false;
					me.errorAddResearcherMessage = '';
					me.addMemberDialog = false;
					me.isAddingStaff = false;
				})
				.catch(function (e) {
					me.isAddingStaff = false;
					// Update staff even on error. The error may be with sending the email and the user has access now.
					me.updateStaff();
					if (e.response.status >= 400 && e.response.status <= 599) {
						me.errorAddResearcher = true;
						me.errorAddResearcherMessage = e.response.data.messages ? e.response.data.messages[0] : 'There was an error adding this staff member.';
					}
				})
		},
		addNew() {
			const me = this;
			this.isAddingStaff = true;
			var newStaffInfo = {
				email: this.email,
				firstName: this.firstName,
				lastName: this.lastName,
				organization: this.organization,
				phoneNumber: this.phoneNumber
			}
			researcherApiService.addNewStaff(this.studyUuid, newStaffInfo)
				.then(function (response) {
					console.log(response);
					me.updateStaff();
					me.errorAddResearcher = false;
					me.errorAddResearcherMessage = '';
					me.addMemberDialog = false;
					me.isAddingStaff = false;
				}).catch(function (e) {
					me.isAddingStaff = false;
					me.updateStaff();
					if (e.response.status >= 400 && e.response.status <= 599) {
						console.log('addNew:: e:', e)
						console.log('addNew:: e.response:', e.response)
						// not getting response data messages back, think its an error with StudyController.java controllerResponse
						// me.errorAddResearcher = true;
						// me.errorAddResearcherMessage = e.response.data.messages.length > 0 ? e.response.data.messages[0] : 'There was an error adding this staff member.';
						me.errorAddResearcher = true;
						me.errorAddResearcherMessage = 'There was an error adding this staff member.';
					}
				})
		},
		onCancelAddStaff() {
			this.addMemberDialog = false;
			this.addStaffSelection = null;
			this.email = '';
			this.firstName = '';
			this.lastName = '';
			this.organization = '';
			this.phoneNumber = null;
			this.errorAddResearcher = false;
			this.errorAddResearcherMessage = '';

			switch (this.addStaffSelection) {
				case '1':
					this.$refs.form1.resetValidation();
					break;
				case '2':
					this.$refs.form2.resetValidation();
			}
		},
		async removeSelected() {
			this.removeDialogLoading = true;
			for (var i = 0; i < this.selected.length; i++) {
				try {
					await researcherApiService.removeStaffFromStudy(this.studyUuid, this.selected[i].userUuid)
						.then(
							this.$store.dispatch('changeUpdateStatusWithMessage', {
								status: 'generic-success',
								message: `The selected study staff have been removed successfully`
							})
						);
				} catch (e) {
					this.$store.dispatch('changeUpdateStatusWithMessage', {
						status: 'generic-error',
						message: `There was an error removing ${this.selected[i].userName}`
					});
				}
			}
			this.selected = [];
			this.updateStaff();
			this.removeDialogLoading = false;
			this.removeStaffDialog = false;
		},
		clearError() {
			this.errorAddResearcher = false;
			this.errorAddResearcherMessage = '';
		}
	}
}
</script>

<style>
.remove-dialog {
	width: 96%;
}

</style>
